/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const VideoPlayIcon = /*#__PURE__*/ createSvgIcon(
  'VideoPlayIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.583 13.125L13 10.312a.359.359 0 00.167-.316.341.341 0 00-.167-.309L8.583 6.876a.346.346 0 00-.385-.016.353.353 0 00-.198.329v5.618c0 .157.066.27.198.34s.26.062.385-.021zM3.5 16c-.413 0-.766-.147-1.06-.44A1.446 1.446 0 012 14.5V5.493c0-.413.147-.765.44-1.056A1.45 1.45 0 013.5 4h13c.413 0 .766.147 1.06.44.293.295.44.648.44 1.06v9.006c0 .413-.147.765-.44 1.056A1.45 1.45 0 0116.5 16h-13zm0-1.5h13v-9h-13v9z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default VideoPlayIcon;
